import { ButtonBase, styled as muiStyled } from '@mui/material'
import ReactPlayer from 'react-player'

export const ReadyToTakeFirstStepCardContainer = muiStyled('div')(
  ({ theme }) => `
    background: #000000cc;
    max-height: 560px;
    height: 50vh;
    position:relative;
    overflow:hidden;
    .content {
      gap: 80px;
      display:flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 36px;
      text-align: center;
      height: 100%;
      width: 100%;
      display: flex;
        flex-direction: column;
        z-index: 1;
    }
    .heading {
        font-size: 1em;
        font-weight: 500;
        color: #fff;
    }
    .button-text {
        font-size: 0.4em;
    }
    @media(min-width:768px){
        .button-text {
            font-size: 0.3em;
        }
        .content{
            font-size: 54px;
        }
    }
    `,
)
export const ReadyToTakeFirstStepCardButtonContainer = muiStyled('div')(
  ({ theme }) => `
    display: flex;
    align-items: center;
    max-width: 700px;
    margin: 0 auto;
    justify-content: center;
    width: 100%;
    padding: 0px 40px;
    gap: 20px;
    flex-direction: column;
    @media(min-width: 768px){
        justify-content: space-between;
        flex-direction: row;
    }
`,
)

export const ReadyToTakeFirstStepButton = muiStyled(ButtonBase)(
  ({ theme }) => `
    background-color: #cad2fe;
    color: #000;
    padding: 10px 20px;
    border-radius: 30px;
    font-weight: 700;
    letter-spacing: 2px;
    max-width: 230px;
    width: 100%;
    transition: background-color 300ms ${theme.transitions.easing.quickInOut};
    font-size: 20px;
    &:hover{
        background-color: #a9b8f9;
    }
    @media (min-width: 768px) {
        max-width: 290px;
      font-size: 24px;
  `,
)
export const ReadyToTakeFirstStepCardOverlay = muiStyled('div')(
  ({ theme }) => `
  background: #000000b3;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;
  pointer-events: none;
  backdrop-filter: blur(1px);
`,
)
export const ReadyToTakeFirstStepCardVideo = muiStyled(ReactPlayer)(
  ({ theme }) => `
  background: #000;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100% !important;
    height: 100% !important;
    video {
        object-fit: cover;
        width: 100vw;
        height: 100%;
    }
 `,
)
